import api from '@/lib/axios';

export const clientesService = {
  async findAll(companyId: string, search?: string) {
    const response = await api.get('/customers', { params: { companyId, search } });
    return response.data;
  },

  async findById(id: string) {
    const response = await api.get(`/customers/${id}`);
    return response.data;
  },

  async create(data: { companyId: string; name: string; phone?: string; email?: string; address?: string; rfc?: string; creditLimit?: number }) {
    const response = await api.post('/customers', data);
    return response.data;
  },

  async update(id: string, data: any) {
    const response = await api.patch(`/customers/${id}`, data);
    return response.data;
  },

  async deactivate(id: string) {
    const response = await api.delete(`/customers/${id}`);
    return response.data;
  },

  async bulkCreate(items: any[]) {
    const response = await api.post('/customers/bulk', { items });
    return response.data;
  },
};
